// Shared helpers so every StudentPortal hook unwraps API responses the same
// way instead of repeating optional-chaining in each one.

export const unwrap = (response, fallback = null) => response?.data?.data ?? fallback;

export const unwrapList = (response) => {
  const data = unwrap(response, []);
  if (Array.isArray(data)) return data;
  return data?.data || data?.items || [];
};
